/**
 * SCRUM-1032 QC round 6, item 3 — which line the toolbar shows while a save
 * runs.
 *
 * "Status of saving after all station is filled and saved before. After edit
 * saved and edit again, the status looks weird, it is showing saving… 479 of
 * 479 (I have 479 stations)" (Wei Woon).
 *
 * `saved` and `total` describe the list, which is what the step is judged on.
 * While a pass is running they answer the wrong question: on a finished list
 * they are equal, so editing two rows again reads as "Saving… 479 of 479" —
 * true, useless, and impossible to tell from a save that has hung.
 *
 * So a pass with rows in flight says what it is doing, and only a pass with no
 * such count falls back to the list figures.
 */

export interface SavingProgressInput {
  /** Rows this pass is writing. */
  inFlight?: number
  /** Rows written across the whole list. */
  saved: number
  pending: number
  total: number
  etaSeconds?: number | null
}

export type SavingProgressLabel = {
  key: string
  values: Record<string, string | number>
}

export const savingProgressLabel = ({
  inFlight,
  saved,
  pending,
  total,
  etaSeconds,
}: SavingProgressInput): SavingProgressLabel => {
  if (inFlight && inFlight > 0) {
    return {
      key:
        inFlight === 1
          ? 'stationsProgressSavingChangesOne'
          : 'stationsProgressSavingChangesOther',
      values: { count: inFlight },
    }
  }

  const listTotal = total || saved + pending

  if (etaSeconds != null) {
    return {
      key: 'stationsProgressSavingWithEta',
      values: { saved, total: listTotal, eta: etaSeconds },
    }
  }

  return {
    key: 'stationsProgressSaving',
    values: { saved, total: listTotal },
  }
}
